<script>
  import Messages from "#lib/Messages.svelte";
  let { data } = $props();
</script>

<Messages {...data} />